<panel width="500">
	<h1>{{'team.credentials' | translate }}</h1>
	<list-view #credentialList scrollable [selectable]="false">
		<header defaultSort="descending"></header>
		<header>{{ 'team.credentials.credential' | translate }}</header>
		<row *listData="let credential from credentials" (action)="enable(credential)" (action)="onChange()">
			<column [sortValue]="credential.wasEnabled"><input type="checkbox" [(checked)]="credential.enabled" (change)="onChange()" /></column>
			<column>{{ 'credential.' + credential.key | translate }}</column>
		</row>
	</list-view>
	<add-multiple
		[label]="'team.custom-credntials' | translate"
		[placeholder]="'team.custom-credntials.add-placeholder' | translate"
		[selectedItems]="customCredentialItems"
		[emitNewValues]="true"
		(selectedItemsChange)="onChangeCustomCredentials($event)"
		[availableItems]="sharedCustomCredentialItems" />
	<section>
		<button #saveButton (click)="save()" [active]="canSave">{{ 'general.save' | translate }}</button>
	</section>
</panel>
